import { createAction } from 'redux-actions';
import Types from './types';

export const getEnvironmentMaintenanceRequest = createAction(
  Types.GET_ENVIRONMENT_MAINTENANCE_REQUEST
);
export const getEnvironmentMaintenanceFulfilled = createAction(
  Types.GET_ENVIRONMENT_MAINTENANCE_FULFILLED
);
export const getEnvironmentMaintenanceRejected = createAction(
  Types.GET_ENVIRONMENT_MAINTENANCE_REJECTED
);

export const getClientMaintenanceRequest = createAction(
  Types.GET_CLIENT_MAINTENANCE_REQUEST
);
export const getClientMaintenanceFulfilled = createAction(
  Types.GET_CLIENT_MAINTENANCE_FULFILLED
);
export const getClientMaintenanceRejected = createAction(
  Types.GET_CLIENT_MAINTENANCE_REJECTED
);

export const setEnvironmentMaintenanceRequest = createAction(
  Types.SET_ENVIRONMENT_MAINTENANCE_REQUEST
);
export const setEnvironmentMaintenanceFulfilled = createAction(
  Types.SET_ENVIRONMENT_MAINTENANCE_FULFILLED
);
export const setEnvironmentMaintenanceRejected = createAction(
  Types.SET_ENVIRONMENT_MAINTENANCE_REJECTED
);

export const setClientMaintenanceRequest = createAction(
  Types.SET_CLIENT_MAINTENANCE_REQUEST
);
export const setClientMaintenanceFulfilled = createAction(
  Types.SET_CLIENT_MAINTENANCE_FULFILLED
);
export const setClientMaintenanceRejected = createAction(
  Types.SET_CLIENT_MAINTENANCE_REJECTED
);

export const getEnvironmentMaintenanceHistoryRequest = createAction(
  Types.GET_ENVIRONMENT_MAINTENANCE_HISTORY_REQUEST
);
export const getEnvironmentMaintenanceHistoryFulfilled = createAction(
  Types.GET_ENVIRONMENT_MAINTENANCE_HISTORY_FULFILLED
);
export const getEnvironmentMaintenanceHistoryRejected = createAction(
  Types.GET_ENVIRONMENT_MAINTENANCE_HISTORY_REJECTED
);

export const getClientMaintenanceHistoryRequest = createAction(
  Types.GET_CLIENT_MAINTENANCE_HISTORY_REQUEST
);
export const getClientMaintenanceHistoryFulfilled = createAction(
  Types.GET_CLIENT_MAINTENANCE_HISTORY_FULFILLED
);
export const getClientMaintenanceHistoryRejected = createAction(
  Types.GET_CLIENT_MAINTENANCE_HISTORY_REJECTED
);

export const retrieveEnvironmentMaintenanceHistoryRequest = createAction(
  Types.RETRIEVE_ENVIRONMENT_MAINTENANCE_HISTORY_REQUEST
);
export const retrieveEnvironmentMaintenanceHistoryFulfilled = createAction(
  Types.RETRIEVE_ENVIRONMENT_MAINTENANCE_HISTORY_FULFILLED
);
export const retrieveEnvironmentMaintenanceHistoryRejected = createAction(
  Types.RETRIEVE_ENVIRONMENT_MAINTENANCE_HISTORY_REJECTED
);

export const retrieveClientMaintenanceHistoryRequest = createAction(
  Types.RETRIEVE_CLIENT_MAINTENANCE_HISTORY_REQUEST
);
export const retrieveClientMaintenanceHistoryFulfilled = createAction(
  Types.RETRIEVE_CLIENT_MAINTENANCE_HISTORY_FULFILLED
);
export const retrieveClientMaintenanceHistoryRejected = createAction(
  Types.RETRIEVE_CLIENT_MAINTENANCE_HISTORY_REJECTED
);
